import { Skeleton } from '@mui/material';
import moment from 'moment';
import { useContext } from 'react';

import { SurfaceMarkingContext } from '../../../../../providers/otc-trader/surface-marking-provider';

import './styles.scss';

export const VolatilitySufaceMarkingHeader = () => {
  const {
    volatilityOptions: { surface },
    isCreateUserVolSurfaceLoading,
    surfaceLoading,
  } = useContext(SurfaceMarkingContext);

  const isVolatilitySurfaceLoading = isCreateUserVolSurfaceLoading || surfaceLoading;

  if (!isVolatilitySurfaceLoading && (!surface || Object.keys(surface).length === 0)) {
    return <></>;
  }

  return (
    <div className="volatility-suface-marking-header-container">
      {isVolatilitySurfaceLoading ? (
        <div>
          <Skeleton
            variant="text"
            width={133}
            height={30}
            animation="wave"
            sx={{ bgcolor: '#416077' }}
          />
          <Skeleton
            variant="text"
            width={228}
            height={30}
            animation="wave"
            sx={{ bgcolor: '#416077' }}
          />
        </div>
      ) : (
        <div className="volatility-suface-marking-header-header">
          <h2>{`${surface?.symbol} Vol Surface`}</h2>
          <span>{`${surface?.tag} | ${moment(surface?.timestamp).format('DD MMM YYYY - HH:mm')} UTC`}</span>
        </div>
      )}
    </div>
  );
};
